/**
 * 任务类型
 * @type {{VARIATION: 优化图片, IMAGINE: 想象图片, UPSCALE: 放大图片}}
 */
export const ACTION_TYPE = {
  IMAGINE: "IMAGINE",
  UPSCALE: "UPSCALE",
  VARIATION: "VARIATION",
};

/**
 * 任务状态
 * @type {{"0": string, READY: number, "1": string, CREATED: number, "2": string, SUCCESS: number, "3": string, FAIL: number}}
 */
export const TASK_STATUS = {
  0: "READY",
  READY: 0,
  1: "CREATED",
  CREATED: 1,
  2: "SUCCESS",
  SUCCESS: 2,
  3: "FAIL",
  FAIL: 3,
  4: "TIMEOUT",
  TIMEOUT: 4,
};

export const UPSCALE_TYPES = [
  { name: "左上", value: 1 },
  { name: "右上", value: 2 },
  { name: "左下", value: 3 },
  { name: "右下", value: 4 },
];

export const VARIATION_TYPES = [
  { name: "左上", value: 1 },
  { name: "右上", value: 2 },
  { name: "左下", value: 3 },
  { name: "右下", value: 4 },
];

export const SQUARE_TYPES = [
  {
    name: "最新",
    value: 0,
  },
  { name: "最多下载", value: 1 },
  { name: "最多点赞", value: 2 },
];

export const DRAW_SIZES = [
  {
    name: "头像图",
    value: "1:1",
  },
  {
    name: "手机壁纸",
    value: "1:2",
  },
  {
    name: "文案图",
    value: "3:4",
  },
  {
    name: "社交媒体",
    value: "4:3",
  },
  {
    name: "宣传海报",
    value: "9:16",
  },
  {
    name: "自定义",
    value: "",
  },
];
